<template>
	<div class="pagination" :class="{'text-center':paginationType === 'loadMore'}" ref="el">
		<spinner v-if="paginationType === 'infinite'" />
		<pagination-list v-else-if="paginationType === 'page'" :value="page" :max-pages="maxPages" @input="setPage" />
		<template v-else-if="paginationType === 'loadMore'">
			<p>{{currentLoadMoreText}}</p>
			<bar-loader :current="(viewed/totalCount)*100" />
			<standard-button v-if="viewed !== totalCount" :text="translations.search.showMore" @click.native="setPage(page + 1)" />
		</template>
	</div>
</template>

<script>
	import Spinner from "@vue/components/loaders/Spinner";
	import {mapState} from 'vuex';
	import PaginationList from "@vue/components/search/PaginationList";
	import StandardButton from "@vue/components/bookingflow/StandardButton";
	import BarLoader from "@vue/components/loaders/BarLoader";
	export default {
		name: "LoadMore",
		components: {BarLoader, StandardButton, PaginationList, Spinner},
		computed: {
			...mapState({
				lodgings: 'lodgings',
				paginationType: 'paginationType',
				page: 'page',
				prPage: 'prPage',
				maxPages: 'maxPages',
				totalCount: 'totalCount',
				translations: 'translations',
				search: 'search'
			}),
			viewed(){
				return this.lodgings.length;
			},
			visibleTotalCount(){
				return (typeof this.search.parameters !== 'undefined' && typeof this.search.parameters.ankomst !== 'undefined' && Number(this.totalCount) > 250) ? '250+' : this.totalCount ;
			},
			currentLoadMoreText(){
				return this.translations.search.youHaveSeenxOutOfy.replace('%d1',this.viewed).replace('%d2',this.visibleTotalCount);
			},

		},
		methods: {
			triggerIfElementInViewport(){
				if(this.isElementInViewport(this.$refs['el']))
				{
					this.setPage(this.page + 1);
				}
			},
			setPage(page){
				this.$store.commit('setPage',page)
			},
			isElementInViewport (el) {
				// Special bonus for those using jQuery
				if (typeof jQuery === "function" && el instanceof jQuery) {
					el = el[0];
				}
				
				const rect = el.getBoundingClientRect();
				
				return (
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
					rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
				);
			},

		},
		mounted()
		{
			if(this.paginationType === 'infinite')
			{
				this.triggerIfElementInViewport();
				window.addEventListener('resize', this.triggerIfElementInViewport);
				window.addEventListener('scroll', this.triggerIfElementInViewport);
			}
		},
		beforeDestroy()
		{
			if(this.paginationType === 'infinite')
			{
				window.removeEventListener('resize', this.triggerIfElementInViewport);
				window.removeEventListener('scroll', this.triggerIfElementInViewport);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.pagination{
		p{
			margin-bottom: 5px;
		}
		.bar-loader{
			max-width: 400px;
			margin: 0 auto 10px;
		}
	}
</style>
